export const fixed = (data, symbol = 2) => {
  return parseFloat(data).toFixed(symbol)
}
